import { render, staticRenderFns } from "./CodifierList.vue?vue&type=template&id=b814fd4a&scoped=true&"
import script from "./CodifierList.vue?vue&type=script&lang=js&"
export * from "./CodifierList.vue?vue&type=script&lang=js&"
import style0 from "./CodifierList.vue?vue&type=style&index=0&id=b814fd4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b814fd4a",
  null
  
)

export default component.exports